export const WEPIN_TOKEN = 'wepin:token'
export const WEPIN_TOKENLESS_URL = [
  '/user/login',
  '/user/exist',
  '/user/verify',
  '/user/password-state',
  '/droplink',
]
export const WEPIN_PROMOTION_URL = '/promotion'
